const es = {
	'快跟我一起来<br />SuperChinese学中文吧!': 'Estoy aprendiendo <br />con SuperChinese, ¡Aprende conmigo!',
	'零基础任性学': 'Aprende desde cero',
	'听说读写全面提升': 'Mejora tus habilidades de escucha, lectura, escritura y habla',
	'趣味对话': 'Conversaciones divertidas',
	'100+日常对话等你来': 'Más de 100 conversaciones diarias están aquí para que las aprendas',
	'智能AI': 'Con tecnología IA',
	'个性化学习推荐，由浅入深系统学': 'Experiencias de aprendizaje personalizadas y sistemáticas para que aprendas mejor.',
	'趣味对话等你来': 'Con conversaciones divertidas que te están esperando',
	'立即打开': 'Abrir',
	'我在SuperChinese<br />已累计学习{day}天': 'He usado SuperChinese<br />por <span>{day}</span> días',
	'我在SuperChinese<br />已连续学习{day}天': 'He usado SuperChinese<br />por <span>{day}</span> día(s)',
	'学习生词': 'Vocabulario',
	'学习语法': 'Gramática',
	'口语练习': 'Práctica oral',
	'{n}个': '<span>{n}</span>',
	'{n}次': '<span>{n}</span>veces',
	'点击右上角的按钮,选择在浏览器中打开': 'Haz click en en botón de la esquina superior derecha y escoge "abrir con navegador" para abrir',
	'邀请码': 'Código de invitación',
	'用邀请码注册，参与抽大奖': 'Invita a nuevos usuarios a registrarse y llenar el código de invitación para participar en el sorteo',
}
export default es;